<template>
  <div class="d-flex justify-content-between align-items-center" :class="{ 'mt-2': topMargin }">
    <div>
      <small class="text-muted">{{ heading }}:</small>
    </div>
    <div class="d-flex align-items-center">
      <!-- Original mode -->
      <span v-if="!stacked" class="badge bg-primary text-bg-primary">{{ raw }}/{{ total }}</span>

      <!-- Stacked mode - compact display for accordion buttons -->
      <div v-else class="d-flex align-items-center gap-1">
        <span class="badge bg-success text-bg-success">{{ raw }}</span>
        <span class="text-muted small">/</span>
        <span class="badge bg-info text-bg-info">{{ readyRooms - raw }}</span>
        <span class="text-muted small">/</span>
        <span class="badge bg-secondary text-bg-secondary">{{ total }}</span>
      </div>
    </div>
  </div>
  <div class="progress mt-1" style="height: 4px;">
    <!-- Original mode -->
    <div v-if="!stacked"
         class="progress-bar bg-primary"
         role="progressbar"
         :style="`width: ${percent}%`"
         :aria-valuenow="percent"
         aria-valuemin="0"
         aria-valuemax="100">
    </div>

    <!-- Stacked mode -->
    <template v-else>
      <div class="progress-bar bg-success" role="progressbar"
           :style="`width: ${(raw / total) * 100}%`"
           :aria-valuenow="(raw / total) * 100"
           aria-valuemin="0" aria-valuemax="100">
      </div>
      <div class="progress-bar bg-info" role="progressbar"
           :style="`width: ${((readyRooms - raw) / total) * 100}%`"
           :aria-valuenow="((readyRooms - raw) / total) * 100"
           aria-valuemin="0" aria-valuemax="100">
      </div>
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  heading: {
    type: String,
    required: true
  },
  raw: {
    type: Number,
    required: true
  },
  total: {
    type: Number,
    required: true
  },
  percent: {
    type: Number,
    required: true
  },
  topMargin: {
    type: Boolean,
    required: false,
    default: false
  },
  // Props for stacked mode
  stacked: {
    type: Boolean,
    required: false,
    default: false
  },
  readyRooms: {
    type: Number,
    required: false,
    default: 0
  },
  blockedRooms: {
    type: Number,
    required: false,
    default: 0
  }
})
</script>